/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { JobScheduleDto } from './JobScheduleDto';
import {
    JobScheduleDtoFromJSON,
    JobScheduleDtoFromJSONTyped,
    JobScheduleDtoToJSON,
} from './JobScheduleDto';

/**
 * 
 * @export
 * @interface CreateOrUpdateJobConfigurationDto
 */
export interface CreateOrUpdateJobConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    assignedUsers?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    assignedRoles?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    tasks?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewUsers?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewRoles?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {JobScheduleDto}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    schedule?: JobScheduleDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    $type?: CreateOrUpdateJobConfigurationDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateJobConfigurationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoCreateOrUpdateJobConfigurationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.CreateOrUpdateJobConfigurationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateJobConfigurationDtoTypeEnum = typeof CreateOrUpdateJobConfigurationDtoTypeEnum[keyof typeof CreateOrUpdateJobConfigurationDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateJobConfigurationDto interface.
 */
export function instanceOfCreateOrUpdateJobConfigurationDto(value?: unknown): value is CreateOrUpdateJobConfigurationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateJobConfigurationDtoTypeEnum)[0];
}

export function CreateOrUpdateJobConfigurationDtoFromJSON(json: any): CreateOrUpdateJobConfigurationDto {
    return CreateOrUpdateJobConfigurationDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateJobConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateJobConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'protocols': json['protocols'] == null ? undefined : ((json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        'assignedUsers': json['assignedUsers'] == null ? undefined : json['assignedUsers'],
        'assignedRoles': json['assignedRoles'] == null ? undefined : json['assignedRoles'],
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(TaskInJobDtoFromJSON)),
        'reviewRequired': json['reviewRequired'] == null ? undefined : json['reviewRequired'],
        'reviewUsers': json['reviewUsers'] == null ? undefined : json['reviewUsers'],
        'reviewRoles': json['reviewRoles'] == null ? undefined : json['reviewRoles'],
        'autoApprove': json['autoApprove'] == null ? undefined : json['autoApprove'],
        'schedule': json['schedule'] == null ? undefined : JobScheduleDtoFromJSON(json['schedule']),
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateJobConfigurationDtoToJSON(value?: CreateOrUpdateJobConfigurationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'protocols': value['protocols'] == null ? undefined : ((value['protocols'] as Array<any>).map(ProtocolDtoToJSON)),
        'assignedUsers': value['assignedUsers'],
        'assignedRoles': value['assignedRoles'],
        'targetSystemId': value['targetSystemId'],
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(TaskInJobDtoToJSON)),
        'reviewRequired': value['reviewRequired'],
        'reviewUsers': value['reviewUsers'],
        'reviewRoles': value['reviewRoles'],
        'autoApprove': value['autoApprove'],
        'schedule': JobScheduleDtoToJSON(value['schedule']),
        'isAvailable': value['isAvailable'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value['$type'],
    });
}

